export function slugifyHeading(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

export function normalizeAnchorId(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/^(\d)/, "section-$1");
}

/** Resolves the DOM id for a heading — custom anchorId wins, then slugified title. */
export function resolveHeadingId(text: string, anchorId?: string | null): string {
  const custom = anchorId?.trim() ? normalizeAnchorId(anchorId) : "";
  if (custom) return custom;
  const fromText = slugifyHeading(text);
  return fromText || "section";
}

export function scrollToAnchor(id: string): boolean {
  if (typeof document === "undefined") return false;
  const el = document.getElementById(id);
  if (!el) return false;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  window.history.replaceState(null, "", `#${id}`);
  return true;
}
